import React from 'react';

import eduzzAccountsService from 'v2/services/eduzzAccount';

type IProps = {
  module: string;
  children: React.ReactNode;
};

export const BetaModule = React.memo(({ module, children }: IProps) => {
  if (!module) return <>{children}</>;
  const isBeta = eduzzAccountsService.verifyUserHasBetaModule(module);
  if (!isBeta) return null;
  return <>{children}</>;
});
